module.exports = __webpack_public_path__ + "8b6be7d617b2fee612c7cbcffb993f70.png";